import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import Datetime from "react-datetime";
import Select from "react-select";
import {
  getNetworkMenuId,
  getToken,
  validateProviderPayout,
} from "../../Utils/types";
import {
  GeneratePayoutAction,
  getPayoutDetailsNetworkAction,
  GetPayoutStatus,
} from "../../redux/actions/PayoutAction";
import {
  GetClientListNetwork,
  getMonthsYearsAction,
} from "../../redux/actions/GlobalAction";
import { getAllProviderListNetworkAction } from "../../redux/actions/TestPackageNetworkAction";
import {
  GenerateUnSuccessfulBilling,
  GetBillingAppointmentStatus,
  GetInsurerPayoutCountsNetwork,
  GetStatuQueueDataAction,
  GetTotalAppointmentAction,
  GetTotalBillingDataAction,
  GetTotalClientDataAction,
  sendToQcAction,
} from "../../redux/actions/InsBillAction";

import { AdditionalApptHeader } from "../NetworkPortal/PayOut/AdditionalApptHeader";
import { PayoutSentToQc } from "../NetworkPortal/PayOut/PayoutSentToQc";
import { getSnackbarSuccess, isLoadingAction } from "../../Utils/helper";
import { SearchIcon } from "../../Utils/SvgIcons";
import { placeholderSelectColor } from "../NetworkPortal/NetworkIntelligence/UsageCoverage/helper";
import { InputOptionSelect } from "../../common/InputOptionSelect";
import { clearCurrentPage } from "../NetworkPortal/ProviderProfileDetails/helper";
import { isValidDate } from "../ServicePortal/ProfileDetail/helper";
import { API_URL_WITHOUT_USER } from "../../Utils/API";
import { insIinitialFilterState, funnelCard, StatusQueFunnel } from "./helper";
import { initSendToQc } from "../NetworkPortal/PayOut/helper";
import { TotalBilling } from "./TotalBilling";
import { TotalClient } from "./TotalClient";
import { InsTotalAppointments } from "./InsTotalAppointment";
import { InsUnsuccessfullAppt } from "./InsUnsuccessfullAppt";
import { StatusQueue } from "./StatusQueue";
import { RemoveBilling } from "./RemoveBilling";
import { MoveToBilling } from "./MoveToBilling";
import { AdjustmentAmount } from "./AdjustmentAmount";
import { EditByFinance } from "./EditByFinance";
import { SendToQcBulkUpload } from "../NetworkPortal/PayOut/SendToQcBulkUpload";
import { InsBulkUpdate } from "./InsBulkUpdate";

export const InsurerBilling = () => {
  const [providerValues, setProviderValues] = useState(null);
  const [statusQueue, setStatusQueue] = useState(null);
  const [switchTab, setSwitchTab] = useState("totalPayouts");
  const [statusQueueId, setStatusQueueId] = useState(null);
  const [client, setClient] = useState(null);
  const [searchFilter, setSearchFilter] = useState(insIinitialFilterState);
  const [sendToQcPayload, setSendToQcPayload] = useState(initSendToQc);
  const [header, setHeader] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectAllFlag, setSelectAllFlag] = useState(false);
  const [isOpenAdvance, setIsOpenAdvance] = useState(false);
  const [isOpenSetting, setIsOpenSetting] = useState(false);
  const [isExportToExcel, setIsExporToExcel] = useState(false);
  const [isLoadingExcel, setIsLoadingExcel] = useState(false);
  const [bulkSendToQC, setBulkSendToQC] = useState({ type: "", bool: false });
  const [inputClient, setInputClient] = useState("");
  const [providerDetail, setProviderDetail] = useState([]);
  const [month, setMonth] = useState(null);
  const [showData, setShowData] = useState(false);
  const [bulkRate, setBulkRate] = useState(false);
  const [openModel, setOpenModel] = useState({
    removeBilling: false,
    moveToBilling: false,
    adjustAmount: false,
    editByFin: false,
  });

  const payoutReducer = useSelector((state) => state?.PayoutReducer);
  const globalReducer = useSelector((state) => state?.globalReducer);
  const insBillReducer = useSelector((state) => state?.InsBillingPayout);

  const dispatch = useDispatch();
  let validateBtn = validateProviderPayout()[0]?.subMenus[0];

  const changeHandler = (name, value) => {
    setSearchFilter({ ...searchFilter, [name]: value });
  };

  useEffect(() => {
    dispatch(
      GetClientListNetwork({ clientId: 0, clientName: "", BusinessType: "IBU" })
    );
    dispatch(getMonthsYearsAction());
    dispatch(getAllProviderListNetworkAction());
    // dispatch(GetInsurerPayoutCountsNetwork(searchFilter));
  }, []);

  const sendToQcHandler = async (ref) => {
    setSendToQcPayload();
    let res;
    let clId = providerDetail.map((ele) => {
      return { clientId: ele?.clientId };
    });
    if (switchTab === "totalPayouts") {
      res = await dispatch(
        sendToQcAction({
          ...sendToQcPayload,
          year: providerDetail[0]?.year,
          month: providerDetail[0]?.month,
          qcType: "MONTHWISE",
          BusinessType: searchFilter?.BusinessType,
          clientIds: clId,
        })
      );
      if (res) {
        setTimeout(() => {
          dispatch(getPayoutDetailsNetworkAction(searchFilter));
        }, 1000);
      }
    } else if (switchTab === "totalClient") {
      res = await dispatch(
        sendToQcAction({
          ...sendToQcPayload,
          year: providerDetail[0]?.year,
          month: providerDetail[0]?.month,
          qcType: "PROVIDERWISE",
          BusinessType: searchFilter?.BusinessType,
          clientIds: clId,
        })
      );
      setTimeout(() => {
        dispatch(
          GetTotalClientDataAction({
            ...searchFilter,
            IsPayoutStatus: true,
          })
        );
      }, 1000);
    } else if (switchTab === "totalApppointments") {
      let apID = providerDetail.map((ele) => {
        return { appointmentId: ele?.appointmentId };
      });
      res = await dispatch(
        sendToQcAction({
          ...sendToQcPayload,
          year: providerDetail[0]?.year,
          month: providerDetail[0]?.month,
          qcType: "APPOINTMENTWISE",
          appointmentIds: apID,
          BusinessType: searchFilter?.BusinessType,
          clientIds: clId,
        })
      );
      setTimeout(() => {
        dispatch(
          GetTotalAppointmentAction({
            ...searchFilter,
            IsPayoutStatus: true,
          })
        );
      }, 1000);
    }
    if (res) {
      isLoadingAction(false, dispatch);
      getSnackbarSuccess("success", res?.data?.message, dispatch);
      ref.current.click();
      setSelectAllFlag(false);
      setSelectAll(false);
      setProviderDetail([]);
      setSendToQcPayload(initSendToQc);
    }
  };
 
  useEffect(() => {
    if (switchTab === "totalApppointments" || switchTab === "totalClient") {
      dispatch(GetPayoutStatus(true, false));
    }
  }, [switchTab === "totalApppointments", switchTab === "totalClient"]);

  const handleDataCount = (e) => {
    setSearchFilter({
      ...searchFilter,
      page: 1,
      rows: e.target.value,
    });
  };
  // useEffect(()=>{
  //   dispatch(GetBillingAppointmentStatus(false))
  // },[switchTab])

  useEffect(() => {
    handleSearch();
  }, [searchFilter?.rows]);

  const handleSearch = () => {
    clearCurrentPage(dispatch);
   
    if (switchTab === "totalPayouts") {
      dispatch(GetInsurerPayoutCountsNetwork({ ...searchFilter, page: 1 }));
      dispatch(GetTotalBillingDataAction({ ...searchFilter, page: 1 }));
    } else if (switchTab === "totalClient") {
      dispatch(GetInsurerPayoutCountsNetwork({ ...searchFilter, page: 1 }));
      dispatch(GetTotalClientDataAction({ ...searchFilter, page: 1 }));
    } else if (
      switchTab === "totalApppointments" ||
      switchTab === "unSuccessfullAppointments"
    ) {
      dispatch(GetInsurerPayoutCountsNetwork({ ...searchFilter, page: 1 }));
      dispatch(
        GetTotalAppointmentAction({
          ...searchFilter,
          IsPayoutStatus: switchTab === "totalApppointments" ? true : false,
          page: 1,
        })
      );
    } else if (switchTab === true) {
      dispatch(GetInsurerPayoutCountsNetwork({ ...searchFilter, page: 1,Isfunnel:true }));
      dispatch(GetStatuQueueDataAction(searchFilter));
    }
    setSelectAll(false);
    setProviderDetail([]);
    setSelectAllFlag(false);
  };

  const handleSorting = async (type) => {
    changeHandler("SortDirection", type);
    if (switchTab === "totalPayouts") {
      dispatch(
        GetTotalBillingDataAction({ ...searchFilter, SortDirection: type })
      );
    } else if (switchTab === "totalClient") {
      dispatch(
        GetTotalClientDataAction({
          ...searchFilter,
          SortDirection: type,
        })
      );
    } else if (
      switchTab === "totalApppointments" ||
      switchTab === "unSuccessfullAppointments"
    ) {
      dispatch(
        GetTotalAppointmentAction({
          ...searchFilter,
          IsPayoutStatus: switchTab === "totalApppointments" ? true : false,
          SortDirection: type,
        })
      );
    } else if (switchTab === true) {
      dispatch(GetStatuQueueDataAction(searchFilter));
    }
  };

  const downloadFile = (ele) => {
    isLoadingAction(true, dispatch);
    setIsLoadingExcel(true);
    
    // console.log("lola  pola switchTab",switchTab);
    // return
    let apid;
    let clId = providerDetail.map((ele) => {
      return { clientId: ele?.clientId };
    });
    let mthId = providerDetail.map((ele) => {
      return ele?.month;
    });
    let sortMonth = mthId.sort();
    let mth = [];
    for (let i = 0; i < sortMonth.length; i++) {
      if (sortMonth[i] !== sortMonth[i + 1]) {
        mth.push({ monthId: sortMonth[i] });
      }
    }
    if (
      switchTab === "totalApppointments" ||
      switchTab === "unSuccessfullAppointments"
    ) {
      apid = providerDetail.map((ele) => {
        return { AppointmentId: ele?.appointmentId };
      });
    }
    let url;
    if (switchTab === true) {
      url = `${API_URL_WITHOUT_USER}/NetworkPayout/ExportToExcelOtherStatusAppointmentsDetails`;
    } else {
      url = `${API_URL_WITHOUT_USER}/NetworkPayout/ExportToExcelInsurerPayoutDetailsNetwork`;
    }
    let data;
    {
      if (switchTab === "totalPayouts") {
        let cli = searchFilter?.clients;
        data = {
          ...searchFilter,
          isPayoutStatus: true,
          month: ele?.month
          //clients: [{ clientId: cli[0]?.clientId, BusinessType: "IBU" }],
        };
      } else if (switchTab === "totalClient" && selectAll === false) {
        data = {
          ...searchFilter,
          isPayoutStatus: true,
          payoutMonths: mth,
          month: ele?.month,
          clients: providerDetail?.length>=2 ? providerDetail?.map((i)=>{
            return {
              clientId:i?.clientId,
              clientName:i?.clientName
            }
          }): [{clientId:ele?.clientId,clientName:ele?.clientName}],
        };
      } else if (switchTab === "totalClient" && selectAll === true) {
        data = {
          ...searchFilter,
          isPayoutStatus: true,
          // clients: [],
          // payoutMonths: mth,
          // month: searchFilter?.month,
          //   "",
        };
      } else if (switchTab === "totalApppointments" && selectAll === false) {
        data = {
          ...searchFilter,
          isPayoutStatus: true,
          appointmentIds: apid,
          payoutMonths: mth,
          month: ele?.month,
          clients:clId,
        };
      } else if (switchTab === "totalApppointments" && selectAll === true) {
        data = {
          ...searchFilter,
          isPayoutStatus: true,
          // clients: clId,
        };
      } else if (
        switchTab === "unSuccessfullAppointments" &&
        selectAll === false
      ) {
        data = {
          ...searchFilter,
          isPayoutStatus: false,
          appointmentIds: apid,
          payoutMonths: mth,
          month: ele?.month,
          clients: clId,
        };
      } else if (
        switchTab === "unSuccessfullAppointments" &&
        selectAll === true
      ) {
        data = {
          ...searchFilter,
          isPayoutStatus: false,
          // clients: [],
        };
      } else if (switchTab === true) {
        
        data = {
          ...searchFilter,
          isPayoutStatus: statusQueueId?.isPayoutStatus,
          isBillingDetails: statusQueueId?.isBillingDetails,
          isExportToExcel: true,
        };
      }
    }

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken(),
        MenuId: getNetworkMenuId()?.menuId,
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.blob())
      .then((blob) => {
        isLoadingAction(false, dispatch);
        let filename;
        if (switchTab === true) {
          filename = "appointmentDetail.csv";
        } else {
          filename = "InsurerBillingDetails.xlsx";
        }
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setIsLoadingExcel(false);
        setSelectAllFlag(false);
        setSelectAll(false);
        setProviderDetail([]);
      })
      .catch((error) => {
        console.error("Failed to fetch the file");
        setIsLoadingExcel(false);
        // isLoadingAction(false, dispatch);
      });
  };

  const generatePayout = async () => {
    let clId = providerDetail.map((ele) => {
      return { clientId: ele?.clientId };
    });
    let apID = providerDetail.map((ele) => {
      return { appointmentId: ele?.appointmentId };
    });
    if (!searchFilter?.month) {
      getSnackbarSuccess("warning", "Please select month", dispatch);
      return;
    } else {
      let res = await dispatch(
        GenerateUnSuccessfulBilling({
          ...searchFilter,
          clients: clId,
          appointmentIds: apID,
        })
      ).then((res) => {
        isLoadingAction(false, dispatch);
        getSnackbarSuccess("success", res?.data?.message, dispatch);
        setTimeout(() => {
          dispatch(
            GetTotalAppointmentAction({
              ...searchFilter,
              IsPayoutStatus: false,
              page: 1,
            })
          );
          dispatch(GetInsurerPayoutCountsNetwork({ ...searchFilter, page: 1 }));
          setProviderDetail([]);
        }, 1000);
      });
    }
  };

  const handleStatusQueueFunnelData = (ele) => {
    if (
      ele?.value === "totalApppointments" ||
      ele?.value === "unSuccessfullAppointments"
    ) {
      dispatch(GetPayoutStatus(true, false));
    } else if (ele?.value === "totalCases") {
      dispatch(GetPayoutStatus(false, false));
    }
  };

  const handleClear = () => {
    setClient(null);
    setProviderValues(null);
    setProviderDetail([]);
    setInputClient("");
    setSearchFilter(insIinitialFilterState);
    setShowData(false);
    setMonth(new Date().getMonth + 1);

    if (switchTab === "totalPayouts") {
      dispatch(GetTotalBillingDataAction(insIinitialFilterState));
      dispatch(GetInsurerPayoutCountsNetwork(insIinitialFilterState));
    } else if (switchTab === "totalClient") {
      dispatch(GetTotalClientDataAction(insIinitialFilterState));
      dispatch(GetInsurerPayoutCountsNetwork(insIinitialFilterState));
    } else if (
      switchTab === "totalApppointments" ||
      switchTab === "unSuccessfullAppointments"
    ) {
      dispatch(
        GetTotalAppointmentAction({
          ...insIinitialFilterState,
          IsPayoutStatus: switchTab === "totalApppointments" ? true : false,
        })
      );
      dispatch(GetInsurerPayoutCountsNetwork(insIinitialFilterState));
    } else if (switchTab === true) {
      setStatusQueueId({
        value: "totalCases",
        isPayoutStatus: false,
        isBillingDetails: false,
        requestStatusId: "-1",
      });
      setStatusQueue("totalCases")
      dispatch(
        GetStatuQueueDataAction({
          ...insIinitialFilterState,
          requestStatusId: -1,
          isPayoutStatus: false,
          isBillingDetails: false,
        })
      );
      dispatch(
        GetInsurerPayoutCountsNetwork({
          ...insIinitialFilterState,
          requestStatusId: -1,
        })
      );
    }
  };

  return (
    <div className="right-section pt-1 pt-3" style={{ padding: "10px" }}>
      <div className="card staff-details-section">
        <div className="card-body">
          <div className="d-flex justify-content-between">
            <h4>Insurer Billing</h4>
            {insBillReducer?.getInsurerPayoutCount?.length > 0 && <div class="form-switch mapToggleBtn d-flex pt-2">
              <h6 style={{ width: "100%" }} className="pt-1">
                Status Queue
              </h6>
              <input
                class="form-check-input"
                type="checkbox"
                role="switch"
                id="flexSwitchCheckDefault"
                onChange={async (e) => {
                  setSearchFilter({ ...searchFilter, requestStatusId: null });
                  if (e.target.checked === true) {
                    setSwitchTab(e.target.checked);
                    setProviderDetail([]);
                    setStatusQueue("totalCases");
                    // dispatch(GetStatuQueueDataAction(searchFilter));
                  } else if (e.target.checked === false) {
                    setSwitchTab("totalPayouts");
                    setStatusQueue(null);
                    setStatusQueueId(null);
                    // setMonth(new Date().getMonth + 1);
                    // setSearchFilter(insIinitialFilterState)
                    dispatch(GetInsurerPayoutCountsNetwork({ ...searchFilter, requestStatusId: null }));
                    // dispatch(GetTotalBillingDataAction(searchFilter));
                  }
                }}
              />
            </div>}
            
          </div>
          <div className="mt-3 d-flex flex-wrap gap-3">
            <div className="payputMultiSelect">
              <Select
                placeholder="Client ID/Name"
                getOptionLabel={(option) => option.clientName}
                getOptionValue={(option) => option.clientId}
                className="basic-multi-select usagecoverage-search"
                classNamePrefix="select"
                isMulti
                styles={placeholderSelectColor}
                closeMenuOnSelect={false}
                name="colors"
                onChange={(event, i, value) => {
                  changeHandler("clients", event);
                }}
                value={
                  searchFilter?.clients === "" ? null : searchFilter?.clients
                }
                inputValue={inputClient}
                onInputChange={(value, action) => {
                  if (action.action === "input-change") setInputClient(value);
                  if (action.action === "menu-close") {
                    setInputClient("");
                  }
                }}
                options={globalReducer?.getClientList?.map((ele) => {
                  return {
                    clientId: ele?.clientId,
                    clientName: ele?.clientName,
                    BusinessType: ele?.businessType,
                  };
                })}
                hideSelectedOptions={false}
                components={{
                  Option: InputOptionSelect,
                }}
              />
            </div>

            <div className="payoutBussinessType">
              <Datetime
                dateFormat="YYYY"
                timeFormat={false}
                className="page-content payoutYearFilter"
                isValidDate={isValidDate}
                value={searchFilter?.year}
                placeholder="Select Year"
                closeOnSelect={true}
                onChange={(e) =>
                  setSearchFilter({
                    ...searchFilter,
                    year: e?.format("YYYY"),
                  })
                }
              />
            </div>

            <div className="payoutBussinessType">
              <select
                name="BusinessType"
                className="white-form-select "
                style={{ height: "60px" }}
                value={month}
                onChange={(e) => {
                  setMonth(e.target.value);
                  setSearchFilter({
                    ...searchFilter,
                    month: e.target.value ? e.target.value :null ,
                  });
                }}
              >
                <option value=""> Select Month</option>
                {globalReducer?.getMonthYear?.lstMonths?.map((ele) => {
                  return (
                    <option value={+ele?.monthId}>{ele?.monthName}</option>
                  );
                })}
              </select>
            </div>
            {(switchTab === "totalApppointments" 
            //||switchTab === "totalClient"
          ) && (
              <div className="payoutBussinessType">
                <select
                  name="Select Status"
                  className="white-form-select "
                  style={{ height: "60px" }}
                  value={
                    searchFilter?.requestStatusId === null
                      ? "0"
                      : searchFilter?.requestStatusId
                  }
                  onChange={(e) => {
                    setSearchFilter({
                      ...searchFilter,
                      requestStatusId: e.target.value,
                    });
                  }}
                >
                  <option value="0"> Select Status</option>
                  {payoutReducer?.getpayoutStatus?.map((ele) => (
                    <option value={ele?.requestStatusId}>
                      {ele?.displayName}
                    </option>
                  ))}
                </select>
              </div>
            )}
            {(statusQueue === "totalCases" ||
              statusQueue === "totalApppointments") && (
              <div className="payoutBussinessType">
                <select
                  name="Select Status"
                  className="white-form-select "
                  style={{ height: "60px" }}
                  value={
                    searchFilter?.requestStatusId === null
                      ? "-2"
                      : searchFilter?.requestStatusId
                  }
                  onChange={(e) => {
                    setSearchFilter({
                      ...searchFilter,
                      requestStatusId: e.target.value,
                    });
                  }}
                >
                  <option value="-2"> Select Status</option>
                  {payoutReducer?.getpayoutStatus?.map((ele) => (
                    <option value={ele?.requestStatusId}>
                      {ele?.displayName}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>
          <br />
          {switchTab !== true && (
            <>
              {insBillReducer?.getInsurerPayoutCount?.length > 0 && (
                <div className=" gap-4 d-flex  flex-wrap">
                  {funnelCard.map((ele) => {
                    return (
                      <div
                        className="payout-funnel-card"
                        onClick={() => {
                          setSwitchTab(
                            ele?.value === "closedCases"
                              ? "totalApppointments"
                              : ele?.value
                          );
                          setSelectAll(false);
                          setSelectAllFlag(false);
                          setProviderDetail([]);
                          setSearchFilter({
                            ...searchFilter,
                            requestStatusId: "0",
                            page: 1,
                            caseNo: "",
                          });
                          // dispatch(
                          //   GetInsurerPayoutCountsNetwork({
                          //     ...searchFilter,
                          //     requestStatusId: "0",
                          //     caseNo: "",
                          //   })
                          // );
                        }}
                      >
                        <div
                          className={`${
                            switchTab === ele?.value
                              ? "payOutSwitchTab"
                              : "payOutSwitchTab1"
                          } servce_box`}
                          onClick={() => setHeader([])}
                        >
                          <div>
                            <img src={ele?.img} alt="exportsquare" />
                          </div>
                          <div>
                            <p>{ele?.header}</p>
                            <h3>
                              {insBillReducer?.getInsurerPayoutCount[0][
                                ele?.value
                              ]?.toLocaleString("en-IN")}
                            </h3>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </>
          )}
          {switchTab === true && (
            <div className=" gap-4 d-flex  flex-wrap">
              {StatusQueFunnel.map((ele) => {
                return (
                  <div
                    className="payout-funnel-card"
                    onClick={() => {
                      setStatusQueue(ele?.value);
                      setStatusQueueId(ele);

                      setSearchFilter({
                        ...searchFilter,
                        page: 1,
                        rows: 10,
                        requestStatusId: ele?.requestStatusId,
                        isPayoutStatus: ele?.isPayoutStatus,
                        isBillingDetails: ele?.isBillingDetails,
                      });
                      dispatch(
                        GetStatuQueueDataAction({
                          ...searchFilter,
                          page: 1,
                          rows: 10,
                          requestStatusId: ele?.requestStatusId,
                          isPayoutStatus: ele?.isPayoutStatus,
                          isBillingDetails: ele?.isBillingDetails,
                        })
                      );
                      handleStatusQueueFunnelData(ele);
                    }}
                  >
                    <div
                      className={`${
                        statusQueue === ele?.value
                          ? "payOutSwitchTab"
                          : "payOutSwitchTab1"
                      } servce_box`}
                      // style={{border: "1px solid #5157A0"}}
                      onClick={() => setHeader([])}
                    >
                      <div>
                        <img src={ele?.img} alt="exportsquare" />
                      </div>
                      <div>
                        <p>{ele?.header}</p>
                        <h3>
                          {insBillReducer?.getInsurerPayoutCount[0][
                            ele?.value
                          ]?.toLocaleString("en-IN")}
                        </h3>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          <div className="col-12 d-flex gap-3 pt-2 justify-content-between mb-2">
            <div className="mt-2 gap-5 ">
              <div className=" d-flex gap-1">
                {switchTab !== "totalPayouts" && (
                  <>
                    <select
                      className="row-selectdropdown"
                      value={searchFilter?.rows}
                      onChange={(e) => {
                        handleDataCount(e);
                      }}
                    >
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                    <p className="results">
                      Total{" "}
                      <span>
                        {globalReducer?.getTotalCount?.toLocaleString("en-IN")}
                      </span>{" "}
                      results
                    </p>
                  </>
                )}
              </div>
            </div>
            {(switchTab === "unSuccessfullAppointments" ||
              switchTab === "totalApppointments") && (
              <div className="mt-2">
                <input
                  placeholder="Case No/Policy Ref. No"
                  value={searchFilter?.caseNo}
                  className=" white-form-select  networkInputCaseNo"
                  onChange={(e) =>
                    changeHandler("caseNo", e.target.value.trim(" "))
                  }
                />
              </div>
            )}
            <div className="d-flex gap-3 pt-2  justify-content-end flex-wrap">
              <button
                className="search"
                type="button"
                style={{ border: "none" }}
                onClick={handleSearch}
              >
                <a className="sidebar-links">
                  <SearchIcon />
                  <span className="sidebar-link-text">Search</span>
                </a>
              </button>
              <button
                className="search"
                type="button"
                style={{ border: "none" }}
                onClick={() => handleClear("CBU")}
              >
                <a className="sidebar-links">
                  <span className="sidebar-link-text">Clear All</span>
                </a>
              </button>
              {switchTab === "unSuccessfullAppointments" && (
                <button
                  className="btn search__btn"
                  type="button"
                  disabled={providerDetail?.length === 0}
                  style={{ border: "none" }}
                  onClick={() => generatePayout()}
                >
                  Generate Billing
                </button>
              )}

              {switchTab === "totalApppointments" && (
                <>
                  <button
                    className="ascDescBtn search__btn ps-2 p-1 text-align-center"
                    style={{ textAlign: "center" }}
                    type="button"
                    // disabled={
                    //   validateBtn.informationPermissions[0]?.canEdit === true ||
                    //   validateBtn.informationPermissions[1]?.canEdit === true
                    //     ? false
                    //     : true
                    // }
                    data-bs-toggle="dropdown"
                  >
                    Bulk Action &nbsp;
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="advancePayoutDropdown"
                  >
                    <li>
                      <button
                        className="dropdown-item btn-border-bottom"
                        type="button"
                        onClick={() =>
                          setBulkSendToQC({ type: "qcApproval", bool: true })
                        }
                      >
                        Bulk QC Approval
                      </button>
                    </li>

                    <li>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={() => {
                          setBulkSendToQC({
                            type: "insBulkFinance",
                            bool: true,
                          });
                        }}
                      >
                        Bulk Edit By Finance
                      </button>
                    </li>
                    <li>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={() => {
                          setBulkSendToQC({
                            type: "bulkForInsurer",
                            bool: true,
                          });
                        }}
                      >
                        Bulk For Insurer
                      </button>
                    </li>
                  </ul>
                </>
              )}
              {(switchTab === "totalApppointments" ||
                switchTab === "totalClient") && (
                <button
                  className="btn search__btn"
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#sendToQcModal"
                  disabled={providerDetail?.length < 2}
                  // style={{ border: "none",fontWeight:"600" }}
                  // onClick={sendToQcHandler}
                >
                  QC Approval &nbsp;
                  <i class="fa-solid fa-caret-right"></i>
                </button>
              )}
              {(switchTab === "unSuccessfullAppointments" ||
                switchTab === "totalApppointments" ||
                switchTab === "totalClient") && (
                <>
                {/* lola */}
                  <button
                    disabled={providerDetail?.length < 2 ? true : false}
                    className="btn search__btn"
                    type="button"
                    onClick={downloadFile}
                  >
                    <i className="fa-solid fa-arrow-down"></i>&nbsp;Export To
                    Excel
                  </button>
                </>
              )}
              {switchTab === true && (
                <>
                  <button
                    className="btn search__btn"
                    type="button"
                    onClick={downloadFile}
                  >
                    <i className="fa-solid fa-arrow-down"></i>&nbsp;Export To
                    Excel
                  </button>
                </>
              )}
              {switchTab === "totalClient" && (
                <>
                  <button
                    className="search__btn ascDescBtn"
                    type="button"
                    id="ascDescPayableBtn"
                    data-bs-toggle="dropdown"
                    // aria-expanded="false"
                  >
                    <i className="fa fa-list"></i>
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="ascDescPayableBtn"
                  >
                    <li>
                      <button
                        className="dropdown-item btn-border-bottom"
                        type="button"
                        onClick={() => handleSorting("asc")}
                      >
                        Ascending Order
                      </button>
                    </li>
                    <li>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={() => handleSorting("desc")}
                      >
                        Descending Order
                      </button>
                    </li>
                  </ul>
                </>
              )}

              {(switchTab === "unSuccessfullAppointments" ||
                switchTab === "totalApppointments") && (
                <>
                  <button
                    className="search__btn ascDescBtn p-2"
                    data-bs-toggle="modal"
                    id="ascDescPayableBtn"
                    onClick={() => {
                      setIsOpenSetting(true);
                    }}
                    // data-bs-target="#additionalFilterApptHeader"
                    type="button"
                  >
                    &nbsp;
                    <i
                      class="fa-solid fa-gear"
                      style={{ fontSize: "20px" }}
                    ></i>
                  </button>
                </>
              )}
            </div>
          </div>
          {providerDetail?.length > 0 && (
            <>
              <div className="select_all_div m-2">
                {switchTab === "totalClient" && (
                  <>
                    {!selectAll && (
                      <>
                        <p>{providerDetail?.length} Clients are selected</p>
                        {globalReducer?.getTotalCount > searchFilter.rows && (
                          <>
                            {selectAllFlag === true && (
                              <span
                                className="select_all_primary_cases"
                                onClick={() => setSelectAll(true)}
                              >
                                Select all {globalReducer?.getTotalCount}{" "}
                                Clients
                              </span>
                            )}
                          </>
                        )}
                      </>
                    )}
                    {selectAll && (
                      <p>{globalReducer?.getTotalCount} Clients are selected</p>
                    )}
                  </>
                )}
                {(switchTab === "totalApppointments" ||
                  switchTab === "unSuccessfullAppointments") && (
                  <>
                    {!selectAll && (
                      <>
                        <p>
                          {providerDetail?.length} appointments are selected
                        </p>
                        {globalReducer?.getTotalCount > searchFilter.rows && (
                          <>
                            {selectAllFlag === true && (
                              <span
                                className="select_all_primary_cases"
                                onClick={() => setSelectAll(true)}
                              >
                                Select all {globalReducer?.getTotalCount}{" "}
                                appointments
                              </span>
                            )}
                          </>
                        )}
                      </>
                    )}
                    {selectAll && (
                      <p>
                        {globalReducer?.getTotalCount} appointments are selected
                      </p>
                    )}
                  </>
                )}
              </div>
            </>
          )}
          {switchTab === "totalPayouts" ? (
            <TotalBilling
              setSwitchTab={setSwitchTab}
              switchTab={switchTab}
              searchFilter={searchFilter}
              providerDetail={providerDetail}
              setProviderDetail={setProviderDetail}
              setMonth={setMonth}
              setSearchFilter={setSearchFilter}
              downloadFile={downloadFile}
              isLoadingExcel={isLoadingExcel}
            />
          ) : switchTab === "totalClient" ? (
            <TotalClient
              searchFilter={searchFilter}
              setSwitchTab={setSwitchTab}
              switchTab={switchTab}
              providerDetail={providerDetail}
              setProviderDetail={setProviderDetail}
              sendToQcHandler={sendToQcHandler}
              setSearchFilter={setSearchFilter}
              downloadFile={downloadFile}
              selectAllFlag={selectAllFlag}
              setSelectAllFlag={setSelectAllFlag}
              setSelectAll={setSelectAll}
              isLoadingExcel={isLoadingExcel}
              providerValues={providerValues}
              setProviderValues={setProviderValues}
              header={header}
            />
          ) : switchTab === "totalApppointments" ? (
            <InsTotalAppointments
              searchFilter={searchFilter}
              setSwitchTab={setSwitchTab}
              switchTab={switchTab}
              providerDetail={providerDetail}
              setProviderDetail={setProviderDetail}
              sendToQcHandler={sendToQcHandler}
              setSearchFilter={setSearchFilter}
              downloadFile={downloadFile}
              header={header}
              setHeader={setHeader}
              selectAllFlag={selectAllFlag}
              setSelectAllFlag={setSelectAllFlag}
              setSelectAll={setSelectAll}
              showData={showData}
              setShowData={setShowData}
              insBillReducer={insBillReducer}
              setOpenModel={setOpenModel}
              openModel={openModel}
            />
          ) : switchTab === "unSuccessfullAppointments" ? (
            <InsUnsuccessfullAppt
              searchFilter={searchFilter}
              setSwitchTab={setSwitchTab}
              switchTab={switchTab}
              providerDetail={providerDetail}
              setProviderDetail={setProviderDetail}
              sendToQcHandler={sendToQcHandler}
              setSearchFilter={setSearchFilter}
              downloadFile={downloadFile}
              header={header}
              setHeader={setHeader}
              selectAllFlag={selectAllFlag}
              setSelectAllFlag={setSelectAllFlag}
              setSelectAll={setSelectAll}
              showData={showData}
              setShowData={setShowData}
              insBillReducer={insBillReducer}
            />
          ) : switchTab === true ? (
            <StatusQueue
              searchFilter={searchFilter}
              setSwitchTab={setSwitchTab}
              switchTab={switchTab}
              providerDetail={providerDetail}
              setProviderDetail={setProviderDetail}
              sendToQcHandler={sendToQcHandler}
              setSearchFilter={setSearchFilter}
              downloadFile={downloadFile}
              header={header}
              setHeader={setHeader}
              selectAllFlag={selectAllFlag}
              setSelectAllFlag={setSelectAllFlag}
              setSelectAll={setSelectAll}
              showData={showData}
              setShowData={setShowData}
              insBillReducer={insBillReducer}
              setOpenModel={setOpenModel}
              openModel={openModel}
              statusQueue={statusQueue}
            />
          ) : (
            ""
          )}
          <div
            class="modal fade"
            id="sendToQcModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalCenterTitle"
            aria-hidden="true"
          >
            <PayoutSentToQc
              sendToQcHandler={sendToQcHandler}
              sendToQcPayload={sendToQcPayload}
              setSendToQcPayload={setSendToQcPayload}
              providerDetail={providerDetail}
              setProviderDetail={setProviderDetail}
            />
          </div>

          <Modal
            isOpen={isOpenSetting}
            style={{ maxWidth: "35%" }}
            className=" modal-add-user-popup modal-upload-excel-popup payOutAddHeader"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <AdditionalApptHeader
              setIsOpenSetting={setIsOpenSetting}
              switchTab={switchTab}
              header={header}
              setHeader={setHeader}
              searchFilter={searchFilter}
            />
          </Modal>
          <Modal
            isOpen={openModel?.removeBilling}
            className="modal-add-user-popup modal-upload-excel-popup modal-remove-billing-popup"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <RemoveBilling
              searchFilter={searchFilter}
              setOpenModel={setOpenModel}
              openModel={openModel}
              providerDetail={providerDetail}
              setProviderDetail={setProviderDetail}
            />
          </Modal>
          <Modal
            isOpen={openModel?.moveToBilling}
            className="modal-add-user-popup modal-upload-excel-popup modal-remove-billing-popup"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <MoveToBilling
              searchFilter={searchFilter}
              setOpenModel={setOpenModel}
              openModel={openModel}
              providerDetail={providerDetail}
              setProviderDetail={setProviderDetail}
            />
          </Modal>
          <Modal
            isOpen={openModel?.adjustAmount}
            className="modal-add-user-popup modal-upload-excel-popup EditByFinContainer"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <AdjustmentAmount
              searchFilter={searchFilter}
              setOpenModel={setOpenModel}
              openModel={openModel}
              providerDetail={providerDetail}
              setProviderDetail={setProviderDetail}
            />
          </Modal>
          <Modal
            isOpen={openModel?.editByFin}
            className="modal-add-user-popup modal-upload-excel-popup EditByFinContainer"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <EditByFinance
              searchFilter={searchFilter}
              setOpenModel={setOpenModel}
              openModel={openModel}
              providerDetail={providerDetail}
              setProviderDetail={setProviderDetail}
            />
          </Modal>
          <Modal
            isOpen={bulkSendToQC?.bool}
            className="modal-add-user-popup modal-upload-excel-popup"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <InsBulkUpdate
              setBulkSendToQC={setBulkSendToQC}
              bulkSendToQC={bulkSendToQC}
            />
          </Modal>
        </div>
      </div>
    </div>
  );
};
